import { render, staticRenderFns } from "./ATSScanner.vue?vue&type=template&id=323d841d"
import script from "./ATSScanner.vue?vue&type=script&lang=js"
export * from "./ATSScanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports